import { useEffect, useState, useRef } from "react";

import FullScreenOverlay from '../FullScreenOverlay/FullScreenOverlay';
import './CreateSnack.css'
import { FaPlus } from "react-icons/fa6";
import { get, post } from '../../Services/api';
import upload_image_firebase_storage from "../../Utility/upload_image_firebase_storage";
import Loading from "../Loading/Loading";
import loading_display from "../../Utility/loading_display";

function CreateSnackModal({ currentUser, modalOpen, setModalOpen, setMealSelected }) {
    const [mealName, setMealName] = useState('')

    // Course & Cuisine
    const [allCuisines, setAllCuisines] = useState([])
    const [cuisine, setCuisine] = useState('')

    const [total_calories, setTotal_calories] = useState(0)
    const [total_carb, setTotal_carb] = useState(0)
    const [total_protein, setTotal_protein] = useState(0)
    const [total_fat, setTotal_fat] = useState(0)
    const [total_cost, setTotal_cost] = useState(0)
    const [total_fiber, setTotal_fiber] = useState(0)

    const [img, setImg] = useState()
    // const [modalOpen, setModalOpen] = useState(false)

    const suggestionDivRefs = useRef([]);  // Store refs for each suggestion div

    useEffect(() => {
        // Initiate all values
        constructor()
    }, [])

    async function constructor() {
        try {
            // All cuisines
            const result_cu = await get("/api/meal/get-all-cuisines")
            setAllCuisines(result_cu)

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission behavior
        loading_display(true)

        let img_url = null;
        // image
        if (img) {
            img_url = await upload_image_firebase_storage({ path: '/Meal Images', imageFile: img })
        }

        const meal_data = {
            meal_name: mealName,
            cuisine_id: cuisine,
            course_id: 8,
            cost: total_cost,
            calories: total_calories,
            carb: total_carb,
            protein: total_protein,
            fat: total_fat,
            fiber: total_fiber,
            img: img_url,
            active: true
        }

        try {
            const result = await post("/api/meal/user-create-snack", {
                meal_data: meal_data,
                uid: currentUser.uid
            })

            if (setMealSelected) {
                const mealData = {
                    name: meal_data.meal_name,
                    image: meal_data.img,
                    meal_id: result.data
                }
                meal_data.meal_id = result.data
                setMealSelected(mealData)
                setModalOpen(false)
            } else if (result) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        loading_display(false)
    };


    const fileInputRef = useRef(null);

    const handleDivClick = () => {
        // Trigger the hidden file input click
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setImg(file)
        }
    };

    useEffect(() => {
        if (modalOpen === false) {
            document.getElementById('create_meal_modal').style.display = 'none'
            setModalOpen()
        }
    }, [modalOpen])


    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedOutside = true;

            // Loop through suggestion div refs and check if the click was outside
            suggestionDivRefs.current.forEach((ref, index) => {
                if (ref && ref.contains(event.target)) {
                    clickedOutside = false;  // Click happened inside a suggestion div
                }
            });

        };


        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    function validateNumber(e, set) {

        // Parse the input as a number
        const value = e.target.value;
        const parsedValue = Number(value);
        if ((!isNaN(parsedValue) && parsedValue >= 0 && value)) {
            set(parsedValue);
        } else {
            set(''); // Clear input if invalid
        }

    }

    return (
        <div id="create_meal_modal">
            <FullScreenOverlay modalOpen={modalOpen} setModalOpen={setModalOpen}>
                <div className="create_meal_modal_div gray_scale_2">
                    <form onSubmit={handleSubmit}>
                        <div className="create_meal_modal_action_buttons flex gap_6">
                            <p className="create_meal_modal_action_cancel font_weight_600 cursor_pointer" onClick={() => setModalOpen(false)}>Cancel</p>
                            <button type="submit" className=" create_meal_modal_action_create_meal green_gradient white font_size_14 font_weight_600 cursor_pointer">Create Snack</button>
                        </div>
                        <div className="flex flex_column gap_40">
                            <div className="create_meal_modal_general_detail">
                                <div className="create_meal_modal_left_right_div flex flex_column gap_16 ">
                                    <div>
                                        <p>Snack Name*</p>
                                        <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Name of meal..." value={mealName} onChange={(e) => setMealName(e.target.value)} required />
                                    </div>



                                    <div className="create_meal_modal_minor_details">
                                        <div>
                                            <p>Course*</p>
                                            <select required className="create_meal_modal_meal_unit gray_scale_2 cursor_pointer" disabled>
                                                <option value={8}>Snack</option>
                                            </select>
                                        </div>


                                        <div>
                                            <p>Cuisine*</p>
                                            <select required className="create_meal_modal_meal_unit gray_scale_2 cursor_pointer" onChange={(e) => setCuisine(e.target.value)}>
                                                <option value={''}>---</option>
                                                {allCuisines.map((cuis, i) => (
                                                    <option key={i} value={cuis.cuisine_id} selected={cuisine === cuis.cuisine_id}>{cuis.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="create_meal_modal_course_cousine">
                                        <div>
                                            <p>{'Cost ($)'}</p>
                                            <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Cost" value={total_cost}
                                                onInput={(e) => { validateNumber(e, setTotal_cost) }}
                                                required />
                                        </div>
                                        <div>
                                            <p>Calories</p>
                                            <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Calories" value={total_calories}
                                                onInput={(e) => { validateNumber(e, setTotal_calories) }}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <p>{'Carb (g)'}</p>
                                            <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Carb" value={total_carb}
                                                onInput={(e) => { validateNumber(e, setTotal_carb) }}
                                                required />
                                        </div>
                                        <div>
                                            <p>{'Protein (g)'}</p>
                                            <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Protein" value={total_protein}
                                                onInput={(e) => { validateNumber(e, setTotal_protein) }}
                                                required />
                                        </div>
                                        <div>
                                            <p>{'Fat (g)'}</p>
                                            <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Fat" value={total_fat}
                                                onInput={(e) => { validateNumber(e, setTotal_fat) }}
                                                required />
                                        </div>
                                        <div>
                                            <p>{'Fiber (g)'}</p>
                                            <input className="create_meal_modal_meal_name gray_scale_2" placeholder="Fiber" value={total_fiber}
                                                onInput={(e) => { validateNumber(e, setTotal_fiber) }}
                                                required />
                                        </div>
                                    </div>
                                </div>

                                <div className="create_meal_modal_left_right_div create_meal_modal_image_div flex align_center justify_center cursor_pointer" onClick={handleDivClick}>
                                    {img ?
                                        <img className="create_meal_modal_img" src={URL.createObjectURL(img)} />
                                        : <div className="flex flex_column gap_20 align_center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
                                                <path d="M50.6254 36.125C50.3431 39.8794 48.6593 43.3903 45.9083 45.9607C43.1573 48.5311 39.5402 49.9729 35.7754 50H15.0254C12.3949 49.9973 9.81144 49.3029 7.53409 47.9865C5.25673 46.6702 3.36559 44.778 2.05037 42.5L11.2254 35C12.3411 34.0868 13.7442 33.5984 15.1857 33.6212C16.6273 33.6441 18.0142 34.1769 19.1004 35.125C19.829 35.8016 20.6849 36.3266 21.6183 36.6694C22.5517 37.0122 23.5439 37.166 24.5373 37.1218C25.5306 37.0776 26.5053 36.8363 27.4046 36.4119C28.3038 35.9876 29.1097 35.3887 29.7754 34.65L34.7754 29.2C35.3284 28.5928 35.9993 28.1045 36.7472 27.7649C37.495 27.4254 38.3042 27.2417 39.1254 27.225C39.9477 27.1999 40.7661 27.3471 41.5282 27.6571C42.2902 27.9671 42.979 28.433 43.5504 29.025L50.6254 36.125ZM50.6254 15.025V30.8L46.1754 26.35C45.2612 25.4218 44.1715 24.6847 42.9698 24.1815C41.768 23.6784 40.4782 23.4192 39.1754 23.4192C37.8725 23.4192 36.5827 23.6784 35.381 24.1815C34.1792 24.6847 33.0896 25.4218 32.1754 26.35L31.9254 26.625L26.9254 32.075C26.2334 32.8268 25.2725 33.2748 24.2518 33.3217C23.2311 33.3685 22.2333 33.0103 21.4754 32.325C19.7566 30.8242 17.5691 29.9685 15.2882 29.9046C13.0074 29.8408 10.7754 30.5728 8.97537 31.975L0.500368 38.6C0.260617 37.4159 0.168249 36.2067 0.225368 35V15C0.225018 11.0562 1.77789 7.27085 4.54782 4.46349C7.31776 1.65612 11.0819 0.0525845 15.0254 0H35.8004C39.7482 0.0460613 43.5187 1.64673 46.294 4.45479C49.0693 7.26286 50.6256 11.0519 50.6254 15V15.025ZM19.7754 15.275C19.7754 14.2861 19.4821 13.3194 18.9327 12.4971C18.3833 11.6749 17.6024 11.034 16.6888 10.6556C15.7752 10.2772 14.7698 10.1781 13.7999 10.3711C12.83 10.564 11.9391 11.0402 11.2398 11.7395C10.5406 12.4387 10.0644 13.3296 9.87144 14.2995C9.67852 15.2695 9.77753 16.2748 10.156 17.1884C10.5344 18.102 11.1753 18.8829 11.9975 19.4324C12.8198 19.9818 13.7865 20.275 14.7754 20.275C16.1014 20.275 17.3732 19.7482 18.3109 18.8105C19.2486 17.8729 19.7754 16.6011 19.7754 15.275Z" fill="#C5C1B9" />
                                            </svg>
                                            <p className="gray_scale_3 font_size_20 font_weight_600">Upload Photo</p>
                                        </div>
                                    }
                                </div>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    accept="image/*"
                                />
                            </div>
                        </div>
                    </form>
                </div >
            </FullScreenOverlay >
        </div>
    );
}


export default CreateSnackModal;